import Vue from 'vue'
import App from './App.vue'
import AppBlocked from './AppBlocked.vue'
import AppLoading from './AppLoading.vue'

import { auth } from "./plugins/firebase"
import { setPersistence, signInWithCustomToken, onAuthStateChanged, browserSessionPersistence } from "firebase/auth"

import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
Vue.use(BootstrapVue);

import moment from 'moment'

Vue.config.productionTip = false

Vue.filter('convertDate', (value) => {
  return moment(value).format('DD.MM.YYYY')
})

const params = new URLSearchParams(location.search)
let token = params.get("Token")
if (token === null) token = '0'

setPersistence(auth, browserSessionPersistence)
.then(() => {
  return signInWithCustomToken(auth, token)
})
.catch(error => {
  console.error(error)
  new Vue({
    render: h => h(AppBlocked)
  }).$mount('#app')
})

onAuthStateChanged(auth, (user) => {
  let appView = App
  console.log(user)
  if (!user) {
    appView = AppLoading
  }

  new Vue({
    render: h => h(appView)
  }).$mount('#app')
})
